import {
  ADD_TAB,
  REMOVE_TAB,
  ADD_MEDICINE_TO_TAB,
  SET_ACTIVE_TAB,
  LOAD_TABS_FROM_STORAGE,
  UPDATE_MEDICINE_IN_TAB,
  REMOVE_MEDICINE_FROM_TAB,
} from './saleInvoice.types';
import { Medicine } from 'pages/Medicine/Search/searchTypes';

export const addTab = (id: string, name: string) => ({
  type: ADD_TAB,
  payload: { id, name },
});

export const removeTab = (id: string) => ({
  type: REMOVE_TAB,
  payload: id,
});

export const setActiveTab = (id: string) => ({
  type: SET_ACTIVE_TAB,
  payload: id,
});

export const addMedicineToTab = (tabId: string, medicine: Medicine) => ({
  type: ADD_MEDICINE_TO_TAB,
  payload: { tabId, medicine },
});

export const loadTabsFromStorage = () => {
  const data = localStorage.getItem('medicineSearchTabs');
  if (data) {
    const parsed = JSON.parse(data);
    return { type: LOAD_TABS_FROM_STORAGE, payload: parsed };
  }
  return { type: LOAD_TABS_FROM_STORAGE, payload: { tabs: [], activeTabId: null } };
};

export const updateMedicineInTab = (tabId: string, medicine: Medicine) => ({
  type: UPDATE_MEDICINE_IN_TAB,
  payload: { tabId, medicine },
});

export const removeMedicineFromTab = (tabId: string, medicineId: string) => ({
  type: REMOVE_MEDICINE_FROM_TAB,
  payload: { tabId, medicineId },
});
